import { useQuery } from '@tanstack/react-query';
import { userService } from '../services/api';

export function useUsers() {
  return useQuery({
    queryKey: ['users'],
    queryFn: () => userService.getUsersByPerimeter(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

export function useUser(userId: number) {
  return useQuery({
    queryKey: ['users', userId],
    queryFn: () => userService.getUser(userId),
    enabled: !!userId,
    staleTime: 5 * 60 * 1000,
  });
}